import Urls from "../../urlLink";
import { createApiClient, createApiService } from "../../utils/apiClientFactory";

const client = createApiClient(Urls.crmApiUrl);

const storeHome = createApiService(client, {
  getConversion: ["get", "/Index"],
  getRemind: ["get", "/Index/remindApi"],
  getCalendar: ["get", "/Index/monthEventApi"],
  setSchedule: ["get", "/Index/eventOneApi"],
  addSchedule: ["postForm", "/Index/addEventAction"],
  getMarketerSchool: ["get", "/Index/getMarketerSchoolApi"],
  getschoolMarketer: ["get", "/Index/schoolMarketerApi"],
  settingtrackClient: ["postForm", "/Client/trackClientAction"],
  ChangeUrl: ["get", "/Module/ChangeUrl"],
  getEnrollStuCountApi: ["get", "/Index/getEnrollStuCountApi"],
  getTmkClientRemindApi: ["get", "/Index/getTmkClientRemindApi"],
  getCrmStudentOneApi: ["get", "/CrmStudent/getCrmStudentOneApi"],
  getSchMarketerEnrollApi: ["get", "/Index/getSchMarketerEnrollApi"],
  courseTypeApi: ["get", "/Public/courseTypeApi"],
  courseTypeRecruitApi: ["get", "/Public/courseTypeRecruitApi"],
});

export default storeHome;
